import {createEntityAdapter} from '@reduxjs/toolkit';

import {
    type BatchCompPass,
    type CompPass,
    type CompPassRecipient,
} from 'api/comp-passes/comp-pass.types';
import dayjs from 'utils/dayjs';

/**
 * CRUD adapter for comp pass recipients. Sorts by recipient id (uuidV4).
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const compPassRecipient = createEntityAdapter<CompPassRecipient>({
    selectId: (recipient) => recipient.id,
});

/**
 * CRUD adapter for comp pass batches. Sorts by request creation date (descending).
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const compPassBatch = createEntityAdapter<BatchCompPass>({
    selectId: (batch) => batch.compPassRequestId,
    sortComparer: (a, b) => {
        // Primary sort by request creation date
        const timeA = dayjs(a.created).valueOf();
        const timeB = dayjs(b.created).valueOf();

        if (timeA !== timeB) {
            return timeB - timeA;
        }

        return a.compPassRequestId - b.compPassRequestId;
    },
});

/**
 * CRUD adapter for handling Comp Pass list data within the store.  Default is sorted by the ID (compPassId).
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const passListAdapter = createEntityAdapter<CompPass>({
    selectId: (pass) => pass.compPassId,
});
